import {UserActions} from "../redux_constants/users.constant";
import {LoginAlertConstant} from "../redux_constants/login.alert.constant";
import {isTrue} from "../utils/utils";

const allUsers = {
};

export const usersReducer = (state = allUsers, action) => {
  switch (action.type) {
    case UserActions.ALL_USERS_UPDATE_SUCCESS:
      var updatedInfo = {}
      for (var i = 0; i < action.response.data.results.length; i++){
        let currUser = action.response.data.results[i]
        // Removing all personal groups from the list
        currUser.assigned_groups = currUser.assigned_groups.filter(group => !isTrue(group.personal_to_user))
        updatedInfo[currUser.id] = currUser;
        updatedInfo[currUser.id].displayOrder = i;
      }
      return updatedInfo;
    case LoginAlertConstant.LOGOUT:
      return {};
    default:
      return state;
  }
};
